<button mat-icon-button class="close-button" [mat-dialog-close]="true" style="margin-top:-20px">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<mat-spinner diameter="24" *ngIf="loadingPossibleRecommendations" hidden></mat-spinner>
<div class="margin-bottom-24">
  <mat-form-field style="width: 10vw;">
    <mat-select placeholder="{{'Customer' | translate | async}}" [(ngModel)]="selectedCustomer" (selectionChange)="loadJobSites()" ngDefaultControl >
      <mat-option  [value]="0" > {{'Select Customer'}}  </mat-option>
      <mat-option [value]="customer.Id" *ngFor="let customer of customers">
        {{customer.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style="width: 6vw;">
    <mat-select placeholder="{{'Job Site' | translate | async}}" [(ngModel)]="selectedJobsite" (selectionChange)="loadModels()" ngDefaultControl >
      <mat-option  [value]="0" > {{'Select Jobsite'}}  </mat-option>
      <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsites">
        {{jobsite.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style="width: 10vw;">
    <mat-select placeholder="{{'Model' | translate | async}}" [(ngModel)]="selectedModel" (selectionChange)="loadCompartTypes()" ngDefaultControl >
      <mat-option  [value]="0" > {{'Select Model'}}  </mat-option>
     
      <mat-option [value]="model.Id" *ngFor="let model of models">
        {{model.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style="width: 10vw;">
    <mat-label>Rule(Name) </mat-label>
    <input type="text" matInput [(ngModel)]="_RuleName" required>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Rule Details Desc </mat-label>
    <input type="text" matInput [(ngModel)]="_RuleDesc">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Components Affected</mat-label>
    <input type="text" matInput [(ngModel)]="_Components">
  </mat-form-field>
  <button type="button" mat-raised-button color="warn" style="margin:20px;" [disabled]="savingForm" [class.loading]="savingForm" (click)="setRule()">{{ _RuleId > 0 ? 'Update Rule' : 'Save Rule' | translate | async }}</button>
  <div *ngIf="_RuleId > 0">
    <div>
      <h4 style="color: green;">Components</h4>
      <mat-form-field style="width: 6vw;">
        <mat-select placeholder="{{'CompType' | translate | async}}" [(ngModel)]="selectedCompartType" (selectionChange)="onChangeCompType();" ngDefaultControl required>
          <mat-option [value]="comparttype.Id" *ngFor="let comparttype of comparttypes">
            {{comparttype.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 6vw;">
        <mat-select placeholder="{{'Side' | translate | async}}" [(ngModel)]="selectedCompartSide" ngDefaultControl required>
          <mat-option [value]="side.Id" *ngFor="let side of compartsides">
            {{side.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 6vw;">
        <mat-select placeholder="{{'Pos' | translate | async}}" [(ngModel)]="selectedPosition" ngDefaultControl required>
          <mat-option [value]="pos.Id" *ngFor="let pos of Positions">
            {{pos.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 6vw;">
        <mat-select placeholder="{{'ActionType' | translate | async}}" [(ngModel)]="selectedActionType" ngDefaultControl required>
          <mat-option [value]="actiontype.Id" *ngFor="let actiontype of ActionTypes">
            {{actiontype.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 6vw;">
        <mat-select placeholder="{{'NewPos' | translate | async}}" [(ngModel)]="selectedNewPosition" ngDefaultControl>
          <mat-option [value]="pos.Id" *ngFor="let pos of Positions">
            {{pos.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 9vw;">
        <mat-label>Detailed Description </mat-label>
        <input type="text" matInput [(ngModel)]="selectedDesc">
      </mat-form-field>


      <mat-form-field style="width: 6vw;">
        <mat-label>ExtendedHrs </mat-label>
        <input type="text" matInput [(ngModel)]="selectedExtendedHrs">
      </mat-form-field>

      <mat-form-field style="width: 6vw;">
        <mat-label>Labour $</mat-label>
        <input type="number" matInput [(ngModel)]="selectedLabour">
      </mat-form-field>


      <mat-form-field style="width: 6vw;">
        <mat-label>Parts $</mat-label>
        <input type="number" matInput [(ngModel)]="selectedParts">
      </mat-form-field>

      <mat-form-field style="width: 5vw;">
        <mat-label>Misc $</mat-label>
        <input type="number" matInput [(ngModel)]="selectedMisc">
      </mat-form-field>


      <mat-form-field style="width: 6vw;">
        <mat-label>Total Cost $</mat-label>
        <input type="number" matInput [(ngModel)]="selectedLabour+selectedParts+selectedMisc" [disabled]="true">
      </mat-form-field>
      <div style="margin-left: 32%; position:absolute; vertical-align: middle; align-content:center;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
      </div>
      <div>
        <a class="button" (click)="resetField()" *ngIf="_loadRuleDetailForEdit"><span class="button__text">Cancel</span></a>
        <button type="button" mat-raised-button color="warn" style="margin:20px;" [disabled]="savingForm" [class.loading]="savingForm" (click)="addRuleComponent()">{{ _loadRuleDetailForEdit ? 'Update' : 'Add' | translate | async }}</button>
      </div>
    </div>
  </div>

  <div style="overflow: auto;">
    <mat-table [dataSource]="dataSource" matSort class="table-material table-material--striped table-material--hover table-material--full-width mat-elevation-z8">
      <ng-container matColumnDef="EditCol">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          Edit
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" title="Edit {{element.ComponentType}}">
          <i (click)="editRuleComponent(element)" class="material-icons button__icon"
             style="cursor: pointer;margin-left: 20px;">edit</i>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="CompType">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Comp. Type'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" title="{{element.ComponentType}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.ComponentType}}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Side">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Side'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.SideName}}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Pos">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Pos'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.Position}}">
          <div class="SerialAndUnitText"> {{element.Position}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ActionType">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Action Type'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.ActionType}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.ActionType}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="NewPos">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'New Pos.'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.NewPosition}}">
          <div class="SerialAndUnitText">{{element.NewPosition}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="DetailedDescription">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Detailed Description'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.Description}}">
          <div class="SerialAndUnitText">{{element.Description}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ExtendedHrs">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Extended Hrs'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.LifeExtendedHours}}">
          <div class="SerialAndUnitText">{{element.LifeExtendedHours}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Labour">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Labour'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.LabourCost}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.LabourCost}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Parts">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Parts'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.PartCost}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.PartCost}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Misc">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Misc'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.MiscCost}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.MiscCost}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="TotalCost">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Total Cost'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.LabourCost+element.PartCost+element.MiscCost}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.LabourCost+element.PartCost+element.MiscCost}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="By">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'By'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.CreatedUser}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.CreatedUser}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="CreatedDate">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          {{'Created Date'| translate | async}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.CreatedDate}}">
          <div class="SerialAndUnitText" style="width: max-content;"> {{element.CreatedDate | date: 'dd MMM yyyy'}} </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Delete">
        <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
          Delete
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="tableCell" title="Delete {{element.ComponentType}}">
          <span style="width: max-content; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; cursor: pointer;"><i class="material-icons sc-icon" (click)="deleteRuleDetail(element.RuleComponentId)">delete</i></span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table >
  </div>
</div>
